var React = require('react');

function Laptop1Light (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 2a1 1 0 00-1 1v20a1 1 0 001 1h28a1 1 0 001-1V3a1 1 0 00-1-1H9zm30.69 22.328c.199-.4.31-.851.31-1.328V3a3 3 0 00-3-3H9a3 3 0 00-3 3v20c0 .674.222 1.295.597 1.796-.22.204-.41.44-.562.702l-.001.002-4.664 7.996-.002.004A3 3 0 003.96 38H22v8H1a1 1 0 100 2h46a1 1 0 100-2H24v-8h19.004a3 3 0 002.586-4.5l-4.666-8-.001-.002a3 3 0 00-1.232-1.17zM38.329 26H8.63a1.003 1.003 0 00-.864.5l-.002.004L3.1 34.5v.002A1 1 0 003.962 36h39.035a1 1 0 00.86-1.5l-4.664-7.996-.002-.004a1 1 0 00-.864-.5zM19 33a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"}));
}

Laptop1Light.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Laptop1Light;

Laptop1Light.default = Laptop1Light;
